import React, { useState, useEffect } from 'react';
import './Navbar.css';

const links = [
  { label: 'Menu', href: '#menu' },
  { label: 'Our Story', href: '#about' },
  { label: 'Reviews', href: '#testimonials' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-inner">
        <a href="#hero" className="nav-logo" onClick={(e) => handleNavClick(e, '#hero')}>
          <span className="logo-text">AURUM</span>
          <span className="logo-dot">✦</span>
        </a>

        <nav className={`nav-links ${open ? 'nav-links--open' : ''}`}>
          {links.map((l) => (
            <a key={l.label} href={l.href} className="nav-link" onClick={(e) => handleNavClick(e, l.href)}>
              {l.label}
            </a>
          ))}
          <a href="#contact" className="nav-reserve btn-gold" onClick={(e) => handleNavClick(e, '#contact')}>
            <span>Reserve a Table</span>
          </a>
        </nav>

        <button
          className={`nav-burger ${open ? 'nav-burger--open' : ''}`}
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>
    </header>
  );
}
